import React from "react";

import logo from "../assets/logo.svg";

const Hero = () => (
  <div className="text-center hero my-5">
    <img className="mb-3 app-logo" src={logo} alt="React logo" width="120" />
    <h1 className="mb-4">YOU SHOULD BE BIKING!!!!!!</h1>

    <p className="lead">
      To find out how often, go to this other application --->>>
      <a href="https://everyday.dev.bddevops.com">schedule app</a>
    </p>
  </div>
);

export default Hero;
